<template>
  <div>
    <template v-if="checkCurrentPage">
      <b-form-select
        :value="selectedUserCompany"
        :options="userCompanyOptions"
        @change="onSelectionChange"
        :selected="selectedUserCompanyDropdown"
        v-if="userCompanyOptions"
        class="custom-select"
        style="width: 100% !important"
        :disabled="disableSelector"
      ></b-form-select>
    </template>
    <template v-else>
      <b-row>
        <b-col xs="6" sm="6" md="6" lg="6" xl="6">
          <b-form-select
            :value="selectedUserCompany"
            :options="userCompanyOptions"
            @change="onSelectionChange"
            :selected="selectedUserCompanyDropdown"
            class="custom-select select-home"
            style="width: 100% !important"
            v-if="userCompanyOptions"
            :disabled="disableSelector"
          ></b-form-select>
        </b-col>
        <b-col xs="6" sm="6" md="6" lg="6" xl="6">
          <b-button
            type="submit"
            variant="primary"
            @click.prevent="onUserCompanyCheck"
            :disabled="isLoading"
            class="next-button mt-2 mt-lg-0 mt-md-0 mt-sm-0 width-reset"
          >
            <b-spinner small v-if="isLoading"></b-spinner>
            <span class="sr-only" v-if="isLoading">Betöltés...</span>
            <span v-if="!isLoading">Vállalkozás adatai</span>
          </b-button>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'SelectCompany',
  props: {
    currentPage: String,
    disableSelector: {
      type: Boolean,
      default: false
    }
  },
  async created() {
    if (this.userCompanies[0] && !this.selectedUserCompany) {
      this.$store.commit('setSelectedUserCompany', this.userCompanies[0])
    }
  },
  async mounted() {
    if (!this.userCompanyOptions.length) {
      await this.$store.dispatch('getUserCompanies', {})
    }

    if (this.userCompanies[0] && !this.selectedUserCompany) {
      this.$store.commit('setSelectedUserCompany', this.userCompanies[0])
      this.$store.commit('setSelectedCompany', this.userCompanies[0].companyData)
    }

    const companyId = this.selectedCompany?.flaggerId ?? null

    if (!this.selectedUserCompany && !companyId) {
      // there is no selected userCompany, selelect the first one
      this.$store.commit('setSelectedUserCompany', this.userCompanies[0])
    }
    if (companyId) {
      const userAssignedCompany = this.userCompanies.filter(function(userCompany) {
        return userCompany.companyId == companyId
      })
      if (userAssignedCompany[0]) {
        // select company  dropdown based on companyId query
        //const getCompanyQueryParams = { value: userAssignedCompany[0].companyId }
        //await this.$store.dispatch('getCompany', getCompanyQueryParams)
        this.$store.commit('setSelectedUserCompany', userAssignedCompany[0])
      } else {
        // user not assigned the company or just reloaded the page.
        // selecting the first element of the list
        this.$store.commit('setSelectedUserCompany', this.userCompanies[0])
      }
    }
  },
  computed: {
    ...mapGetters(['isLoading', 'userCompanyOptions', 'selectedUserCompany', 'userCompanies', 'selectedCompany']),
    checkCurrentPage() {
      return this.$router.currentRoute.fullPath == '/company-offers-private' ||
        this.$router.currentRoute.path == '/kkv-result'
        ? true
        : false
    },
    currentPageKkvQualifier() {
      return this.currentPage == 'kkv-qualifier' || this.currentPage?.includes('kkv-result') ? true : false
    },
    selectedUserCompanyDropdown() {
      if (this.selectedUserCompany != null && this.userCompanyOptions != null) {
        const selectedOption = this.userCompanyOptions.filter(
          t => t.value.companyId == this.selectedUserCompany.companyId
        )
        if (selectedOption.length >= 1) return selectedOption[0].value
        else return null
      } else return null
    }
  },
  methods: {
    async applySelectedCompany() {
      if (this.$router.currentRoute.fullPath == '/company-offers-private') {
        await this.$store.dispatch('getCompetitions', { companyId: this.selectedUserCompany.companyId })
      }
      if (this.$router.currentRoute.fullPath == '/home' || this.$router.currentRoute.fullPath == '/kkv-qualifier') {
        const getCompanyQueryParams = { value: this.selectedUserCompany.companyId }
        await this.$store.dispatch('getCompany', getCompanyQueryParams)
      }
      if (this.$router.currentRoute.name == 'Result') {
        this.$emit('onSelectionChange', this.selectedUserCompany.companyId)
      }
    },
    async onUserCompanyCheck() {
      if (!this.selectedUserCompany)
        this.$store.dispatch('notify', {
          newNotification: { type: 'warning', message: 'Nincs kiválasztva cég.' }
        })
      else {
        if (this.$router.currentRoute.fullPath == '/home' && !this.selectedCompany) {
          const getCompanyQueryParams = { value: this.selectedUserCompany.companyId }
          await this.$store.dispatch('getCompany', getCompanyQueryParams)
        }
        await this.applySelectedCompany()
        // the snippet below handles the kKv functions
        if (this.currentPageKkvQualifier) {
          this.$router.push({
            name: 'Result',
            query: { companyId: this.selectedUserCompany.companyId }
          })
          return
        }
        // the snippet below handles the fundMap functions
        if (this.$router.currentRoute.fullPath === '/fund-map') {
          return this.$router.push({
            path: '/fund-map/company-details',
            query: { companyId: this.selectedUserCompany.companyId }
          })
        }
        // snippet below handles the rest occasions on component mounted
        // only change route when user is not on that page
        if (this.$router.currentRoute.fullPath != '/company-offers-private') {
          this.$router.push({
            name: 'CompanyDetails',
            query: { companyId: this.selectedUserCompany.companyId }
          })
        }
      }
    },
    async onSelectionChange(selectedUserCompany) {
      if (this.$router.currentRoute.fullPath == '/home') {
        const getCompanyQueryParams = { value: selectedUserCompany.companyId }
        await this.$store.dispatch('getCompany', getCompanyQueryParams)
      }
      this.$store.commit('setSelectedUserCompany', selectedUserCompany)
      this.$store.commit('setSelectedCompany', selectedUserCompany.companyData)
      await this.applySelectedCompany()
    }
  }
}
</script>

<style scoped>
.next-button {
  height: 80px;
  font-size: 24px;
  width: 100%;
}

@media screen and (min-width: 990px) {
  .next-button {
    width: max-content;
  }
}

#search-input {
  border-radius: 10px;
  color: var(--color-green);
  padding: 20px;
  border-color: var(--color-green) !important;
  border: 2px solid !important;
}

select,
option,
.custom-select {
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  width: 100% !important;
  border-radius: 8px !important;
  color: var(--color-gray-04) !important;
  background-size: 12px !important;
  height: 48px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #dfe6e9;
}

.select-home {
  min-height: 80px !important;
  font-size: 24px;
  background-size: 24px !important;
}

.kkvCustomSelect select,
.kkvCustomSelect option,
.kkvCustomSelect {
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  width: 100% !important;
  color: white;
  background-color: #00903c !important;
  border: 2px solid white !important;
  border-radius: 5px !important;
  min-height: 3rem;
}

.kkvCustomButton {
  border: 2px solid white !important;
}

.search-input-icon {
  border-bottom-right-radius: 15px;
  border-top-right-radius: 15px;
}

form {
  max-width: 100%;
}

.width-reset {
  width: 100% !important;
}
</style>
